<template>
  <template-layout :customMenu="customMenu">
    <div class="pb-12 px-2 sm:px-4">
        <Breadcrumb :bread-crumb-list="breadcrumbComputed" class="mb-2" />
        <div class="w-1/6 h-1/6 mx-auto" v-if="loadingSurveyData">
            <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
        </div>
        <div class="grid grid-cols-2 gap-6" v-else>
            <div class="col-span-2">
                <div class="items-center mb-6">
                    <h1 class="text-lg font-medium mr-auto">
                    รายงานผลการตรวจสอบความถูกต้องของข้อมูลสมาชิกในครัวเรือน
                    </h1>
                </div>
                <div class="box rounded-md shadow-md p-5" v-if="surveyData">
                    <div class="flex flex-col min-w-full md:min-w-0 md:flex-grow">
                        <span class="text-base font-normal text-theme-1 mb-1">
                            {{ `${surveyData.full_name ? surveyData.full_name : "-"}` }}
                        </span>
                        <span class="text-base font-normal text-theme-1 mb-1"
                            >อายุ: {{surveyData?.member_surveys?.age.year+' ปี '+ surveyData?.member_surveys?.age?.month+' เดือน'}}</span
                        >

                        <p class="text-base text-theme-1 font-normal">
                            ที่อยู่: {{ surveyData.full_address ? surveyData.full_address : "-" }}
                        </p>
                        <hr class="mt-3" />
                        <div class="rounded-xl overflow-hidden" v-if="resultError?.isPass">
                            <div class="p-2 pt-4">
                                <div class="flex items-center justify-center gap-3">
                                    <CheckCircleIcon class="h-10 w-10 text-theme-10" />
                                    <h3 class="text-lg font-bold text-theme-10">แบบประเมินผ่านการตรวจสอบ</h3>
                                </div>
                            </div>
                        </div>
                        <div class="rounded-xl overflow-hidden" v-else-if="resultError?.errors?.length >= 0">
                            
                            <div class="p-2">
                                <div class="flex items-center gap-3">
                                    <InfoIcon class="h-10 w-10 text-theme-24" />
                                    <h3 class="text-lg font-bold text-theme-24">ไม่ผ่านการตรวจสอบ พบข้อผิดพลาด {{resultError.errors.length}} รายการ</h3>
                                </div>
                            </div>

                            <div class="p-6 pt-2">
                                <ul class="text-left space-y-3" >
                                    <li
                                        v-for="(err, index) in resultError.errors"
                                        :key="index"
                                        class="flex items-start gap-3 p-3 bg-red-50/50 rounded-lg border border-red-100"
                                        :class="canJumpToError(err) ? 'cursor-pointer hover:bg-red-100/60 transition-colors' : ''"
                                        @click="canJumpToError(err) ? jumpToError(err) : null"
                                    >
                                        <span class="text-gray-700">{{index + 1}}. {{ err.message }}</span>
                                        <ArrowRightIcon v-if="canJumpToError(err)" class="h-4 w-4 text-theme-24 ml-auto mt-1 flex-shrink-0" />
                                    </li>
                                </ul>
                            </div>

                            <div class="bg-gray-50 p-5 border-t border-gray-100 flex justify-end gap-3">
                                <button
                                    class="btn btn-primary bg-primary-btn border-primary-btn mr-1 mb-2"
                                    @click="toEditPage"
                                    
                                    :disabled="!getPermissionAccessMenu('update') && onlineComputed"
                                >
                                    <Edit2Icon class="h-3 w-3 mr-2" />แก้ไข
                                </button>
                                <button
                                    @click="exportExcelErrorList"
                                    class="btn btn-primary bg-primary-btn border-primary-btn mr-1 mb-2"
                                    :disabled="!getPermissionAccessMenu('update') && onlineComputed"
                                >
                                    <DownloadIcon class="h-3 w-3 mr-2" />นำออก Excel
                                </button>
                            </div>
                        </div>
                        <div class="rounded-xl overflow-hidden" v-else>
                            
                            <div class="p-2 pt-4">
                                <div class="flex items-center justify-center gap-3">
                                    <XCircleIcon class="h-10 w-10 text-theme-24" />
                                    <h3 class="text-lg font-bold text-theme-24">การตรวจสอบผิดพลาด กรุณาลองใหม่อีกครั้ง</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template-layout>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import TemplateLayout from "@/layouts/top-navbar-menu/Main.vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import axios from "axios";
import Swal from "sweetalert2";
import { validateSurveyData } from "@/utils/checkMemberSurvey";
import { getPermissionAccessMenu } from "@/utils/getPermission";
import { utils, writeFile } from "xlsx"
import Breadcrumb from "@/components/breadcrumb/index.vue"

const store = useStore()
const route = useRoute()
const router = useRouter()
const surveyData = ref(null)
const customMenu = ref([])
const onlineComputed = computed(()=> store.getters["network/isOnline"])
const loadingSurveyData = ref(false)
const resultError = ref(null)

const canJumpToError = (err) => {
    // return surveyData.value?.status === 'DRAFT'
    //     && getPermissionAccessMenu('update')
    //     && !!err?.step
    return true
}

const jumpToError = (err) => {
    if (!canJumpToError(err)) return
    if (route.params.type === "member"){
        router.push({
            name: 'edit-member',
            params: { hhid: surveyData.value.house_id, surveyid: route.params.surveyid, memberid: route.params.memberid },
            query: {
                step: err.step,
                q: err.questionCode,
                from: 'verify'
            }
        })
    }
    else if (route.params.type === "neets"){
        router.push({
            name: 'edit-neet',
            params: { surveyid: route.params.surveyid, memberid: route.params.memberid, neetid:route.params.cnid },
            query: {
                step: err.step,
                q: err.questionCode,
                from: 'verify'
            }
        })
    }
    else if (route.params.type === "cwd"){
        router.push({
            name: 'edit-cwd',
            params: { surveyid: route.params.surveyid, memberid: route.params.memberid, cwdid: route.params.cnid },
            query: {
                step: err.step,
                q: err.questionCode,
                from: 'verify'
            }
        })
    }
}
const toEditPage = () => {
    if (route.params.type === "member"){
        router.push({
            name: 'edit-member',
            params: { hhid: surveyData.value.house_id, surveyid: route.params.surveyid, memberid: route.params.memberid },
            query: { from: 'verify' }
        })
    }
    else if (route.params.type === "neets"){
        router.push({
            name: 'edit-neet',
            params: { surveyid: route.params.surveyid, memberid: route.params.memberid, neetid:route.params.cnid },
            query: { from: 'verify' }
        })
    }
    else if (route.params.type === "cwd"){
        router.push({
            name: 'edit-cwd',
            params: { surveyid: route.params.surveyid, memberid: route.params.memberid, cwdid: route.params.cnid },
            query: { from: 'verify' }
        })
    }
}

const getSurvey = async () =>{
    const token = store.getters["userAuth/getToken"];
    const url = `${process.env.VUE_APP_BASE_API}member/${route.params.memberid}?house_survey_id=${route.params.surveyid}`;
    const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": `application/json; charset=utf-8`,
    };
    loadingSurveyData.value = !loadingSurveyData.value
    const res = await axios.get(url, { headers }).catch(() =>
        Swal.fire({
            icon: "warning",
            text: "ระบบผิดพลาด",
        })
    );
    if (res.status === 200) {
        surveyData.value = res.data
        if (route.params.type === "member"){
            const memberSurvey = surveyData.value.member_surveys
            Object.assign(memberSurvey, { full_name: surveyData.value.full_name, age: surveyData.value.member_surveys.age, full_address: surveyData.value.full_address, gender: surveyData.value.gender, prefix_name: surveyData.value.prefix_name, marital_status: surveyData.value.marital_status, HH047: route.query.HH047 })
            surveyData.value.status = res.data.member_surveys.status
            resultError.value = await validateSurveyData(route.params.type, memberSurvey)
        }
        else if (route.params.type === "neets"){
            if(Array.isArray(surveyData.value.neet_survey)){
                const neetSurvey = surveyData.value.neet_survey.find(s => s._id === route.params.cnid)
                Object.assign(neetSurvey, { full_name: surveyData.value.full_name, age: surveyData.value.member_surveys.age, full_address: surveyData.value.full_address, gender: surveyData.value.gender, prefix_name: surveyData.value.prefix_name, marital_status: surveyData.value.marital_status, IN046: surveyData.value.member_surveys.IN046, IN064: surveyData.value.member_surveys.IN064, IN114: surveyData.value.member_surveys.IN114 })
                
                surveyData.value.status = neetSurvey.status
                resultError.value = await validateSurveyData(route.params.type, neetSurvey)
            }
        }
        else if (route.params.type === "cwd"){
            if(Array.isArray(surveyData.value.cwd_survey)){
                const cwdSurvey = surveyData.value.cwd_survey.find(s => s._id === route.params.cnid)
                Object.assign(cwdSurvey, { full_name: surveyData.value.full_name, age: surveyData.value.member_surveys.age, full_address: surveyData.value.full_address, IN105: surveyData.value.member_surveys.IN105 })
                
                surveyData.value.status = cwdSurvey.status
                resultError.value = await validateSurveyData(route.params.type, cwdSurvey)
            }
        }
        loadingSurveyData.value = !loadingSurveyData.value
    }
}

const exportExcelErrorList = () => {
    const errorList = resultError.value?.errors ?? []
    if(errorList.length > 0){
        const worksheetData = errorList.map((err, index) => ({
            "ลำดับ": index + 1,
            "ข้อความผิดพลาด": err.message
        }))
        const ws = utils.json_to_sheet(worksheetData)
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Error List");
        let date = new Date()
        let current_date = [date.getFullYear(),String(date.getMonth() + 1).padStart(2, '0'),String(date.getDate()).padStart(2, '0'),String(date.getHours()).padStart(2, '0'),String(date.getMinutes()).padStart(2, '0'),String(date.getSeconds()).padStart(2, '0')].join('')
        let file_name = `error_list_household_${current_date}`
        writeFile(wb, `${file_name}.xlsx`);
    }
}
// const getCustomMenu = () => {
//     if(householdData.value?.house_surveys?.length > 0){
//         let sub_menu = []
//         for(let i = householdData.value.house_surveys.length; i > 0; i-- ){
//             sub_menu.push({
//                 icon: '',
//                 pageName: 'household-profile',
//                 title: `ครั้งที่ ${i}` ,
//                 params: {
//                     hhid: householdData.value._id,
//                     surveyid: householdData.value.house_surveys[i-1]["_id"]
//                 },
//                 path: `/household/${householdData.value._id}/${householdData.value.house_surveys[i-1]["_id"]}`
//             })
//         }
//         customMenu.value = [
//             {key: "devider"},
//             {
//                 icon: "FileTextIcon",
//                 title: "แบบสำรวจ",
//                 subMenu: sub_menu
//             }
//         ]
//         const idx = householdData.value.house_surveys.findIndex(x=>x._id == route.params.surveyid)
//         const dataMember = householdData.value.house_surveys[idx]?.member_surveys ?? []
//         if(dataMember.length > 0){
//             let member_menu = []
//             for(let i = 0; i < dataMember.length; i++ ){
//                 member_menu.push({
//                     pageName: 'view-member',
//                     title: `${dataMember[i].name} ${dataMember[i].surname}` ,
//                     params: {
//                         hhid: householdData.value._id,
//                         surveyid: householdData.value.house_surveys[idx]._id,
//                         memberid: dataMember[i].member_id
//                     },
//                     path: `/member/view/${householdData.value._id}/${householdData.value.house_surveys[idx]._id}/${dataMember[i].member_id}`,
//                     image: dataMember[i]?.image?.img_url ? process.env.VUE_APP_IMG_API+dataMember[i].image.img_url : "default"
//                 })
//             }
//             customMenu.value = [...customMenu.value, {key: "devider"}, {icon: "UsersIcon",title: "สมาชิกในครัวเรือน",subMenu: member_menu}]
//         }
//     }
// }
const breadcrumbComputed = computed(()=>{
    let breadcrumbList = [
        {
            name: "ครัวเรือน",
            path: "main-house-hold",
        },
    ]
    if(surveyData.value){
        if(route.params.type === "member") {
            breadcrumbList.push(
                {
                    name: "ข้อมูลครัวเรือน",
                    path: "household-profile",
                    param:{
                        hhid: surveyData.value.house_id,
                        surveyid: route.params.surveyid
                    }
                },
                {
                    name: "ข้อมูลสมาชิก",
                    path: "view-member",
                    param:{
                        hhid: surveyData.value.house_id,
                        surveyid: route.params.surveyid,
                        memberid: route.params.memberid
                    }
                },
                {
                    name: "ผลการตรวจสอบความถูกต้อง",
                    active: true,
                }
            )
        }
        else {
            if(route.params.type === 'neets') {
                breadcrumbList.push(
                    {
                        name: "ข้อมูลครัวเรือน",
                        path: "household-profile",
                        param:{
                            hhid: surveyData.value.house_id,
                            surveyid: route.params.surveyid
                        }
                    },
                    {
                        name: "ข้อมูลสมาชิก",
                        path: "view-member",
                        param:{
                            hhid: surveyData.value.house_id,
                            surveyid: route.params.surveyid,
                            memberid: route.params.memberid
                        }
                    },
                    {
                        name: "ข้อมูล NEETs",
                        path: "view-neet",
                        param:{
                            surveyid: route.params.surveyid,
                            memberid: route.params.memberid,
                            neetid: route.params.cnid
                        }
                    },
                    {
                        name: "ผลการตรวจสอบความถูกต้อง",
                        active: true,
                    }
                )
            }
            else {
                breadcrumbList.push(
                    {
                        name: "ข้อมูลครัวเรือน",
                        path: "household-profile",
                        param:{
                            hhid: surveyData.value.house_id,
                            surveyid: route.params.surveyid
                        }
                    },
                    {
                        name: "ข้อมูลสมาชิก",
                        path: "view-member",
                        param:{
                            hhid: surveyData.value.house_id,
                            surveyid: route.params.surveyid,
                            memberid: route.params.memberid
                        }
                    },
                    {
                        name: "ข้อมูลเด็กพิการ",
                        path: "view-cwd",
                        param:{
                            surveyid: route.params.surveyid,
                            memberid: route.params.memberid,
                            cwdid: route.params.cnid
                        }
                    },
                    {
                        name: "ผลการตรวจสอบความถูกต้อง",
                        active: true,
                    }
                )
            }
        }
    }
    
    return breadcrumbList
})

onMounted(async ()=>{
    if(onlineComputed.value){
        await getSurvey()
        // getCustomMenu()
    }
})

</script>

<style lang="scss">
</style>